import { create } from 'zustand'

interface ShortcutsDialogState {
	isOpen: boolean
	setOpen: (isOpen: boolean) => void
}

export const useShortcutsDialogStore = create<ShortcutsDialogState>()(set => ({
	isOpen: false,
	setOpen: isOpen => set({ isOpen }),
}))
